import { MRT_TableInstance } from 'material-react-table';
import { TableMain } from 'src/presentations/components/molecules/table/TableComponents';
import { UnifiedTablePagination } from '../../table/UnifiedTablePagination';

interface SettingsBaseTableProps<T extends Record<string, any>> {
  table: MRT_TableInstance<T>;
  totalItems: number;
  pageSizeOptions?: number[];
  pagination: {
    pageIndex: number;
    pageSize: number;
  };
  onChangePage: (page: number) => void;
  onChangePageSize: (pageSize: number) => void;
  hidePagination?: boolean;
}

/**
 * SettingsBaseTable - A table component with pagination that takes a pre-configured table instance
 * This component is more focused than UnifiedTable, as it takes a fully configured table instance
 */
export function SettingsBaseTable<T extends Record<string, any>>({
  table,
  totalItems,
  pageSizeOptions = [100, 500, 1000],
  pagination,
  onChangePage,
  onChangePageSize,
  hidePagination,
}: SettingsBaseTableProps<T>) {
  return (
    <div className='w-full h-full flex flex-col'>
      <div className='flex-1 overflow-auto'>
        <TableMain
          table={table}
          tableContainerProps={{
            sx: {
              height: '100%',
              maxHeight: '100%',
              '& .MuiTable-root': {
                borderCollapse: 'separate',
              },
              // '& .MuiTableHead-root': {
              //   position: 'sticky',
              //   top: 0,
              //   zIndex: 1,
              // },
            },
          }}
        />
      </div>
      {!hidePagination && (
        <div className='p-12 xl:p-16 bg-neutral-10 flex items-center justify-between border-t border-neutral-20'>
          <UnifiedTablePagination
            pageIndex={pagination.pageIndex}
            pageSize={pagination.pageSize}
            totalItems={totalItems}
            onPageChange={onChangePage}
            onPageSizeChange={onChangePageSize}
            pageSizeOptions={pageSizeOptions}
          />
        </div>
      )}
    </div>
  );
}
